import { AppThunk } from '../reducers';
import { getInquiryList, getUnreadCounts } from '../client/v1/inquiry';
import {
  requestingInquiryList,
  receivedInquiryList,
  requestingUnreadCounts,
  receivedUnreadCounts,
} from './types/InquiryActionTypes';

export const fetchUnreadCounts = (): AppThunk<Promise<void>> => {
  return (dispatch) => {
    dispatch(requestingUnreadCounts());
    return getUnreadCounts()
      .then((response) => {
        if (response) {
          dispatch(receivedUnreadCounts(response));
        }
      })
      .catch((error: Error) => {
        throw error;
      });
  };
};

export const fetchInquiryList = (): AppThunk<Promise<void>> => {
  return (dispatch) => {
    dispatch(requestingInquiryList());
    return getInquiryList()
      .then((response) => {
        if (response) {
          dispatch(receivedInquiryList(response));
        }
      })
      .catch((error: Error) => {
        throw error;
      });
  };
};
